
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertHeaderGroupIec as ObiAlertHeaderGroupIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-header-group-iec.js';
 
 
 

 
 export const ObiAlertHeaderGroupIec = createComponent({
   react: React,
   tagName: 'obi-alert-header-group-iec',
   elementClass: ObiAlertHeaderGroupIecElement,
   events: {
     
   }
  });
 
 